import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    failed: {
        id: 'settings.sumsub.failed',
        defaultMessage: 'Failed to load script',
    },
})
